import { useEffect, useState } from "react"
import BookingForm from "../../components/bookingForm/BookingForm"
import CartesExplain from "../../components/cartesExplain/CartesExplain";
import { IDataCartes } from "../../models/component/carteExplain/datacartes";
import MenuService from "../../services/api/menu.service";
import { useParams } from "react-router-dom";

const Choice = () => {
  const { id } = useParams();
  const [arrayCarte, setArrayCarte] = useState<IDataCartes[]>([]);

  useEffect(() => {
    if(id == "pizzas"){
      handlePizzaChoice()
    } else {
      handleNoPizzaChoice()
    }
  }, []);

  const handleNoPizzaChoice = () => {
    MenuService.getAllMenu()
      .then((r) => {
        console.log(r);
        const filteredData = r.data.filter((item: IDataCartes) => item.name !== "PIZZAS");
        setArrayCarte(filteredData);
      })
      .catch((e) => {
        console.log(e);
        setArrayCarte([]);
      });
  }

  const handlePizzaChoice = () => {
    MenuService.getAllMenu()
      .then((r) => {
        console.log(r);
        const filteredData = r.data.filter((item: IDataCartes) => item.name == "PIZZAS");
        setArrayCarte(filteredData);
      })
      .catch((e) => {
        console.log(e);
        setArrayCarte([]);
      });
  }

  return (
    <div className="view-cartes">
      <div className="container-title">
        <div className="title">Cartes</div>
      </div>
      <div className="container-cartes">
        {/* Passage des données mockées comme prop */}
        <CartesExplain menu={arrayCarte} />
      </div>
      <BookingForm />
    </div>
  );
};

export default Choice;


